import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'column',
  },
  settingsCard: {
    width: '100%',
    backgroundColor: colors.white,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  textStyle: {
    fontWeight: '800',
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 8,
  },
  customContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
  },
});
